"use strict";
(self["webpackChunktom_bihn"] = self["webpackChunktom_bihn"] || []).push([[524],{

/***/ 524:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ productImageSlider)
/* harmony export */ });
/* harmony import */ var swiper_bundle__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4128);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9755);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_1__);



function productImageSlider({ wrapper }) {
  let mainSlider
  let thumbnailSlider
  let originalMainSlides = []
  let originalThumbSlides = []
  let currentVariant = null;

  function init() {
    // Store original slides
    originalMainSlides = Array.from(wrapper.querySelectorAll('[data-hook="main-slider"] .swiper-slide'))
    originalThumbSlides = Array.from(wrapper.querySelectorAll('[data-hook="thumb-slider"] .swiper-slide'))
    
    // Get current variant before initializing sliders
    currentVariant = getVariantOnLoad();
    
    // Filter slides before initializing sliders
    const filteredMainSlides = filterSlidesByVariant(originalMainSlides, currentVariant)
    const filteredThumbSlides = filterSlidesByVariant(originalThumbSlides, currentVariant)

    // Clear existing slides
    const mainSliderWrapper = wrapper.querySelector('[data-hook="main-slider"] .swiper-wrapper')
    const thumbSliderWrapper = wrapper.querySelector('[data-hook="thumb-slider"] .swiper-wrapper')
    
    mainSliderWrapper.innerHTML = ''
    thumbSliderWrapper.innerHTML = ''

    // Add filtered slides
    filteredMainSlides.forEach(slide => {
      mainSliderWrapper.appendChild(slide.cloneNode(true))
    })

    filteredThumbSlides.forEach(slide => {
      thumbSliderWrapper.appendChild(slide.cloneNode(true))
    })
    
    // Initialize thumbnail slider
    thumbnailSlider = new swiper_bundle__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z("[data-hook=thumb-slider]", {
      slidesPerView: 5.5,
      cssMode: false,
      spaceBetween: 10,
      freeMode: false,
      centeredSlides: true,
      centeredSlidesBounds: true,
      watchSlidesProgress: true,
      resistanceRatio: 0,
      breakpoints: {
        1024: {
          spaceBetween: 24
        }
      },
      on: {
        init: function() {
          // Show thumbnail slider after initialization
          this.el.classList.remove('tw-invisible')
          // Add scroll indicators
          addScrollIndicators(this)
        },
        slideChange: function() {
          // Update scroll indicators on slide change
          updateScrollIndicators(this)
        }
      }
    });

    // Initialize main slider
    mainSlider = new swiper_bundle__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z("[data-hook=main-slider]", {
      slidesPerView: 1,
      cssMode: false,
      spaceBetween: 24,
      grabCursor: true,
      centeredSlides: true,
      centeredSlidesBounds: true,
      watchSlidesProgress: true,
      slideToClickedSlide: true,
      resistanceRatio: 0,
      navigation: {
      nextEl: "#shopify-section-" + wrapper.dataset.sectionId + " .swiper-next",
      prevEl: "#shopify-section-" + wrapper.dataset.sectionId + " .swiper-prev"
      },
      thumbs: {
        swiper: thumbnailSlider,
      },
      on: {
        init: function() {
          // Show main slider after initialization
          this.el.classList.remove('tw-invisible')
        }
      }
    });

    // Add click handlers to thumbnail slides to center them when clicked
    thumbnailSlider.slides.forEach((slide) => {
      slide.addEventListener('click', () => {
        const slideIndex = Array.from(thumbnailSlider.slides).indexOf(slide)
        
        // Always center the clicked slide
        thumbnailSlider.slideTo(slideIndex, 300)
      })
    })

    // Open lightbox when clicking main slider images on desktop
    mainSlider.slides.forEach((slide) => {
      slide.addEventListener('click', () => {
        // Only open lightbox on desktop (e.g., 1024px and up)
        if (window.innerWidth >= 1024) {
          const index = mainSlider.slides.indexOf(slide)
          const $lightbox = document.querySelector('.js-lightbox-wrapper')
          $lightbox.style.display = 'block'
          $lightbox.setAttribute('aria-hidden', 'false')
          jquery__WEBPACK_IMPORTED_MODULE_1___default()(document).trigger('lightbox:open', { index, sku: currentVariant.sku })
        }
      })
    });

    jquery__WEBPACK_IMPORTED_MODULE_1___default()(document).on('variant-selector:change', onVariantChange)
  }

  function filterSlidesByVariant(slides, variant) {
    
    if (!variant || !variant.sku) {
      return []
    }
    
    // Log all data-colors values to see what we're working with
    slides.forEach((slide, index) => {
      const colorData = slide.getAttribute('data-colors');
    });
    
    // Filter slides by variant SKU
    const variantSlides = slides.filter(slide => {
      const colorData = slide.getAttribute('data-colors')
      const includesSku = colorData && colorData.includes(variant.sku);
      return includesSku;
    });

    // Get lifestyle images (images with 'visible' and 'lifestyle' in data-colors)
    const lifestyleSlides = slides.filter(slide => {
      const colorData = slide.getAttribute('data-colors')
      const isLifestyle = colorData && colorData.includes('visible') && colorData.includes('lifestyle');
      return isLifestyle;
    });

    // Combine variant slides with lifestyle slides at the end
    let result = [...variantSlides, ...lifestyleSlides];
    
    // If no variant-specific or lifestyle slides found, show all visible slides
    if (result.length === 0) {
      result = slides.filter(slide => {
        const colorData = slide.getAttribute('data-colors')
        return colorData && colorData.includes('visible');
      });
    }
    
    return result;
  }

  function updateSliders(filteredMainSlides, filteredThumbSlides) {
    
    // Hide sliders during update
    mainSlider.el.classList.add('tw-invisible')
    thumbnailSlider.el.classList.add('tw-invisible')

    // Remove all slides first
    while (mainSlider.slides.length > 0) {
      mainSlider.removeSlide(0)
    }
    while (thumbnailSlider.slides.length > 0) {
      thumbnailSlider.removeSlide(0)
    }

    // Add filtered slides
    filteredMainSlides.forEach((slide, index) => {
      mainSlider.addSlide(index, slide.cloneNode(true))
    })

    filteredThumbSlides.forEach((slide, index) => {
      thumbnailSlider.addSlide(index, slide.cloneNode(true))
    })

    // Reset both sliders to first slide
    mainSlider.slideTo(0, 0)
    thumbnailSlider.slideTo(0, 0)
    
    // Update both sliders
    mainSlider.update()
    thumbnailSlider.update()

    // Show sliders after update
    mainSlider.el.classList.remove('tw-invisible')
    thumbnailSlider.el.classList.remove('tw-invisible')

    // Reattach click handlers to new slides
    mainSlider.slides.forEach((slide) => {
      slide.addEventListener('click', () => {
        // Only open lightbox on desktop (e.g., 1024px and up)
        if (window.innerWidth >= 1024) {
          const index = mainSlider.slides.indexOf(slide)
          const $lightbox = document.querySelector('.js-lightbox-wrapper')
          $lightbox.style.display = 'block'
          $lightbox.setAttribute('aria-hidden', 'false')
          jquery__WEBPACK_IMPORTED_MODULE_1___default()(document).trigger('lightbox:open', { index, sku: currentVariant.sku })
        }
      })
    })

    // Reattach click handlers to thumbnail slides
    thumbnailSlider.slides.forEach((slide) => {
      slide.addEventListener('click', () => {
        const slideIndex = Array.from(thumbnailSlider.slides).indexOf(slide)
        
        // Always center the clicked slide
        thumbnailSlider.slideTo(slideIndex, 300)
      })
    })

    // Update scroll indicators after slider update
    updateScrollIndicators(thumbnailSlider)
  }

  function onVariantChange(event, { variant }) {
    currentVariant = variant;
    const filteredMainSlides = filterSlidesByVariant(originalMainSlides, variant)
    const filteredThumbSlides = filterSlidesByVariant(originalThumbSlides, variant)
    updateSliders(filteredMainSlides, filteredThumbSlides)
  }

  function getVariantOnLoad() {
    // Use ?variant param to identify currentVariant, cross-referenced w/ 'product-json' script
    const productJsonElement = document.querySelector('[data-hook="product-json"]');
    
    if (!productJsonElement) {
      return null;
    }

    let productData;
    try {
      productData = JSON.parse(productJsonElement.textContent);
    } catch (e) {
      return null;
    }
    
    let params = new URLSearchParams(document.location.search);
    let variantID = parseInt(params.get('variant'));

    if (!variantID) {
      // If no variant in URL, try to find the first available variant
      if (productData.variants && productData.variants.length > 0) {
        const availableVariant = productData.variants.find(variant => variant.available);
        if (availableVariant) {
          return availableVariant;
        }
        // If no available variant, return the first variant anyway
        return productData.variants[0];
      }
      return null;
    }

    const foundVariant = productData.variants.find((variant) => {
      return variant.id === variantID;
    });
    return foundVariant;
  }

  function addScrollIndicators(swiper) {
    const container = swiper.el;
    
    // Create left fade indicator
    const leftFade = document.createElement('div');
    leftFade.className = 'tw-absolute tw-left-0 tw-top-0 tw-bottom-0 tw-w-8 tw-bg-gradient-to-r tw-from-white tw-to-transparent tw-pointer-events-none tw-z-10 tw-opacity-0 tw-transition-opacity tw-duration-300';
    leftFade.setAttribute('data-scroll-indicator', 'left');
    container.appendChild(leftFade);
    
    // Create right fade indicator
    const rightFade = document.createElement('div');
    rightFade.className = 'tw-absolute tw-right-0 tw-top-0 tw-bottom-0 tw-w-8 tw-bg-gradient-to-l tw-from-white tw-to-transparent tw-pointer-events-none tw-z-10 tw-transition-opacity tw-duration-300';
    rightFade.setAttribute('data-scroll-indicator', 'right');
    container.appendChild(rightFade);
    
    // Set initial state
    updateScrollIndicators(swiper);
  }

  function updateScrollIndicators(swiper) {
    const leftIndicator = swiper.el.querySelector('[data-scroll-indicator="left"]');
    const rightIndicator = swiper.el.querySelector('[data-scroll-indicator="right"]');
    
    if (!leftIndicator || !rightIndicator) return;
    
    // Show left indicator if not at beginning
    if (swiper.isBeginning) {
      leftIndicator.style.opacity = '0';
    } else {
      leftIndicator.style.opacity = '1';
    }
    
    // Show right indicator if not at end
    if (swiper.isEnd) {
      rightIndicator.style.opacity = '0';
    } else {
      rightIndicator.style.opacity = '1';
    }
  }

  // Initialize on load
  init()
}

/***/ })

}]);